





















































































































































































































// Componentes
import uploadLogo from '@/components/Reusable/uploadLogo.vue';
import commerce from '@/store/types/commerce';

import { CommerceParams, NewCommerceParams } from '@/store/interfaces/commerce';
import SweetAlert from '@/util/classes/SweetAlert';
import { currencyKeyboardEventValidation } from '@/util/CurrencyValidation';
import { CommerceKindParams } from '@/store/interfaces/commerceKind';
import { ValidationProvider } from 'vee-validate';
import HttpComponentRequest from '@/util/classes/httpComponentRequest';
import { CompanyParams } from '@/store/interfaces/company';
import { TeipNotifications } from '@/util/teipNotifications';
import { IqueryUrl } from '@/store/interfaces/generic';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'NewCommerceForm',
  components: {
    uploadLogo,
  },
  props: {
    sendingData: {
      required: true,
      default: true,
      type: Boolean,
    },
    clean: {
      required: true,
      default: true,
      type: Boolean,
    },
    modelParams: {
      required: true,
      default: true,
      type: Object as PropType<CommerceParams>,
    },
    commerceList: {
      required: true,
      type: Array,
      default: [] as PropType<CommerceParams[]>,
    },
    commerceKindList: {
      required: true,
      type: Array,
      default: [] as PropType<CommerceKindParams[]>,
    },
    errors: {
      required: true,
      type: [Array, Object],
      default: [],
    },
  },
  data: () => ({
    banner: '',
    company_id: '',
    logo: '',
    merchant: '',
    with_commerce_id: false,
    model: {
      commerce: {
        commerce_kind_id: '',
        description: '',
        is_event: false,
        is_franchise: false,
        logo: '',
        name: '',
      },
      commerce_id: '',
      status: 'inactive',
      tip_percentage: 0,
    },
    infoLogo: null,
    infoBanner: null,
    showInputCompany: true,
    commerces: new HttpComponentRequest<CommerceParams>('name_cont'),
    isLoadingMoreCommerces: false,
    commercesData: [] as CommerceParams[],
    companies: new HttpComponentRequest<CompanyParams>(),
    isLoadingMoreCompanies: false,
    companiesData: [] as CompanyParams[],
  }),
  mounted(): void {
    this.setInitialConfig();
  },
  methods: {
    setInitialConfig(): void {
      this.$data.model = this.$props.modelParams;
      const companyId = this.$route.params.company_id;
      if (companyId) {
        this.$data.company_id = companyId;
        this.$data.showInputCompany = false;
      }

      this.$data.model.commerce_id = '';
    },
    firstFormSubmit(): void {
      this.$emit('send', {
        company_id: this.$data.company_id,
        with_commerce_id: this.$data.with_commerce_id,
        logo: this.$data.logo,
        banner: this.$data.banner,
        merchant: this.$data.merchant,
      });
    },
    cancel(): void {
      const swal = new SweetAlert();
      swal
        .askingSweetAlert({
          title: '¿Estás seguro?',
          text: 'Es posible que los cambios que realizó no se guarden',
          cancelButtonText: 'Salir',
          confirmButtonText: 'Continuar',
          alertType: 'warning',
        })
        .then((res: boolean) => {
          if (!res) {
            this.$data.model.commerce_id = '';
            const company_id = this.$route.params.company_id;
            if (company_id) {
              this.$router.push({
                path: `/commerce/company/${company_id}/comercios#comercios`,
              });
            } else {
              this.$router.push({
                name: 'commerce-partners',
              });
            }

            this.$store.commit(
              `commerceModule/${commerce.mutations.SET_EMPTY_NEW_COMMERCE_PARAMS}`
            );
          }
        });
    },
    keyPressValidation(e: KeyboardEvent, value: number): void {
      currencyKeyboardEventValidation(e, value);
    },
    infoLogoUpload(info: File): void {
      this.$emit('logo', info);
    },
    infoBannerUpload(info: File): void {
      this.$emit('banner', info);
    },
    infoMerchantsLogoUpload(info: File): void {
      this.$emit('merchant', info);
    },
    async getCompaniesFromServer({ url, }: IqueryUrl): Promise<void> {
      this.isLoadingMoreCompanies = true;
      this.companies
        .getHttpRequest(url)
        .then(() => {
          this.companiesData = this.companies.getData;
        })
        .catch(() => {
          const notification = new TeipNotifications();
          notification.warning(
            '¡Error!',
            'No se ha podido obtener información de compañías'
          );
        })
        .finally(() => {
          this.isLoadingMoreCompanies = false;
        });
    },
    async getCommercesFromServer({ url, query, }: IqueryUrl): Promise<void> {
      this.isLoadingMoreCommerces = true;
      this.commerces
        .getHttpRequest(url, query)
        .then(() => {
          this.commercesData = this.commerces.getData;
        })
        .catch(() => {
          const notification = new TeipNotifications();
          notification.warning(
            '¡Error!',
            `No se ha podido obtener información de ${this.$t(
              'menu.commerce.plural.informal'
            )}`
          );
        })
        .finally(() => {
          this.isLoadingMoreCommerces = false;
        });
    },
  },
  watch: {
    errors(error: string[]): void {
      (
        this.$refs.formValidatorNewCommerce as InstanceType<
          typeof ValidationProvider
        >
      ).setErrors(error);
    },
    'model.commerce_id'(val: string): void {
      val !== ''
        ? (this.$data.with_commerce_id = true)
        : (this.$data.with_commerce_id = false);
    },
    model: {
      deep: true,
      async handler(val: NewCommerceParams): Promise<void> {
        this.$emit('input', val);
      },
    },
  },
});
